export const MENU_WIDTH = '6.4rem';
